import { alphabeticalSort, notEqual, Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { EJType, useTypesTableContext } from '../../../../TypesTableContext'
import { useEditEjTypeMutation } from 'schema'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useUserSelectContext } from 'components/CIMSSelect/common/UserSelect/UserSelectContext'

export function useEdit(): EditRowActionOptions<
  EJType,
  CreateEditFormItemsValues
> {
  const { refetch } = useTypesTableContext()
  const { toLabeledValues, fromLabeledValues } = useUserSelectContext()
  const [edit] = useEditEjTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editEJType: {
        type: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditEJType,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, allowanceDescription, users, reportTypeId }) => {
        return {
          name,
          allowanceDescription,
          users: toLabeledValues(users).sort(alphabeticalSort('label')),
          reportTypeId,
        }
      },
      onOk: async (
        { id, name: prevName, allowanceDescription: prevDescription, ...type },
        { name, allowanceDescription, users, reportTypeId }
      ) => {
        const prevUserIds = type.users.map(({ id }) => id)
        const userIds = fromLabeledValues(users)
        const prevReportTypeID = type.reportTypeId
        if (
          prevName !== name ||
          prevDescription !== allowanceDescription ||
          notEqual(prevUserIds, userIds) ||
          notEqual(prevReportTypeID, reportTypeId)
        ) {
          await edit({
            variables: {
              input: {
                id,
                name,
                // Required field, so using bang
                allowanceDescription: allowanceDescription!,
                userIds: users?.map(({ value }) => value.toString()),
                reportTypeId: reportTypeId ?? null,
              },
            },
          })
          refetch()
        }
      },
    },
  }
}
